import { userConstants } from './authConstants';
import { userService } from './authServices';
import { endpoints } from '../../../api/endpoints';

import axios from "axios";

export const userActions = {
  login,
  logout,
  check,
  login_sso,
};

function login(username, password) {
  return dispatch => {
      dispatch(request({ username }));

      return userService.login(username, password)
        .then(
          data => {
            dispatch(success(data));
          },
          error => {
            dispatch(failure(error.toString()));
            throw error;
          }
        );
  };

  function request(user) { return { type: userConstants.LOGIN_REQUEST, user } }
  function success(data) { return { type: userConstants.LOGIN_SUCCESS, data } }
  function failure(error) { return { type: userConstants.LOGIN_FAILURE, error } }
}

function check(cb) {
  return dispatch => {
    dispatch(request());

    return userService.check()
      .then(
        data => {
          dispatch(success(data));
          if (typeof cb === "function") cb(true);
        },
        error => {
          dispatch(failure(error.toString()));
          if (typeof cb === "function") cb(true, false);
        }
      );
  };

  function request() { return { type: userConstants.AUTH_CHECK_REQUEST } }
  function success(data) { return { type: userConstants.AUTH_CHECK_SUCCESS, data } }
  function failure(error) { return { type: userConstants.AUTH_CHECK_FAILURE, error } }
}

function logout(cb) {
  return dispatch => {

    return userService.logout().then(
      () => {
        dispatch(request());
        if (typeof cb === "function") cb(true);
      },
      () => {
        dispatch(request());
        if (typeof cb === "function") cb(true, false);
      }
    );
  };
  function request() { return { type: userConstants.LOGOUT } }
}
  

function login_sso(username, codeOrFalse) {
  return dispatch => {
  dispatch(request({ username, code: codeOrFalse }));

  return userService.login_sso(username, codeOrFalse)
    .then(response => {
      console.log("login_sso response", response);
      // If the response includes a redirect field, handle it:
      if (response && response.redirect) {
        // Dispatch a success action with a payload containing the redirect URL.
        dispatch(success({ redirect: response.redirect }));
        // Optionally, you might decide not to proceed further.
        return { redirect: response.redirect };
      }
      // Otherwise, ensure we have response.data defined
      if (!response || !response.data) {
        dispatch(failure("No data in response"));
        return Promise.reject("No data in response");
      }
      // Dispatch success with the returned data.
      dispatch(success(response));
      return response;
    })
    .catch(error => {
      dispatch(failure(error.toString()));
      console.error("Error in login_sso:", error);
      return Promise.reject(error);
    });
  function request(user) { return { type: userConstants.LOGIN_REQUEST, user } }
  function success(data) { return { type: userConstants.LOGIN_SUCCESS, data } }
  function failure(error) { return { type: userConstants.LOGIN_FAILURE, error } }
}
}

export const sso_redirect_handler = () => async (dispatch) => {
  try {
    console.log("Preparing SSO request...");

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    const session_state = params.get("session_state");

    if (!code || !state || !session_state) {
      dispatch({ type: userConstants.LOGIN_FAILURE, error: "Missing SSO parameters" });
      return Promise.reject("Missing required SSO parameters.");
    }

    const requestData = {
      username: state,
      password:'nopass',  
      generate_refresh_token: true,
      decoded_permissions: true,
      enable_sso: true,
      return_sso_token: code,
    };

    const response = await axios.post(endpoints.user.login, requestData, {
      headers: { "Content-Type": "application/json" }
    });

    console.log("SSO POST Response:", response.data);

    dispatch({ type: userConstants.LOGIN_SUCCESS, data: response.data });

    return response.data; // This is the proper return
  } catch (error) {
    console.error("Error during SSO login redirect handler:", error);
    dispatch({ type: userConstants.LOGIN_FAILURE, data: error.message });
    return Promise.reject(error);
  }
};
